<template>
  <div>
    <div class="container">
      <!--  公司图标  -->
      <div class="logo">
        <button class="menu_button" @click="logo">
          <img style="width: 100px;height: 28px" src="/img/QDLogo.png" alt="加载中...">
        </button>
      </div>

      <div class="logo-right">
        <!--TODO  待实现 搜索图标  -->
<!--        <div class="search">
          <van-icon name="search" size="26"/>
        </div>-->
        <!--  菜单弹窗图标  -->
        <button class="menu" @click="menu">
          <van-icon name="wap-nav" size="34"/>
        </button>
      </div>

      <!--一级菜单标签-->
      <van-popup
          v-model="show_one"
          position="left"
          :style="{ height: '100%' ,width:'140px'}">
        <!--菜单-->
        <div style="margin-top: 6%;margin-left: 2%">
          <van-sidebar style="width: 100%" v-model="activeKey_one"   @change="skip">
            <van-sidebar-item title="首页"  @click="handleItemClick('/')"/>
            <van-sidebar-item title="关于我们"  @click="handleItemClick('/introduction')"/>
            <van-sidebar-item title="产品中心"  @click="handleItemClick('/products')"/>
          </van-sidebar>
        </div>
      </van-popup>

    </div>
  </div>
</template>

<script>
import Vue from 'vue';
/*Sidebar 侧边导航引入*/
import { Sidebar, SidebarItem } from 'vant';
/*图标引入*/
import {Icon} from 'vant';

Vue.use(Sidebar);
Vue.use(SidebarItem);
Vue.use(Icon);

export default {
  data() {
    return {
      show_one: false,
      show_two: false,
      activeKey_one: '11',
    }
  },
  methods: {
    /**
     * 点击菜单按钮
     */
    menu() {
      this.show_one = true
    },
    /**
     * 侧边栏点击事件
     * @param activeKey_one k的值
     */
    skip(activeKey_one){
      console.log('Active sidebar item:',activeKey_one)
    },
    /**
     * 点击菜单跳转页面
     */
    handleItemClick(routePath){
      this.$router.push(routePath);
    },
    /**
     * 点击logo返回首页
     */
    logo() {
      this.$router.push({path: '/'})
    },
  },
  mounted() {
  }
}
</script>

<style scoped>

.container {
  width: 100%;
  display: flex;
  height: 66px;
  text-align: center;
  margin-bottom: 5px;
  box-shadow:2px 0px 10px rgba(0,0,0,0.2);
}

.logo {
  margin-top: 20px;
  flex-grow: 1;
}

.logo-right {
  width: 50%;
  margin-top: 18px;
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
}

.search {
  margin-top: 6px;
}

.menu {
  background-color: transparent;
  border: none;
  outline: none;
  margin: 0 0 10px 10px;
}

.menu:focus {
  outline: none;
}

.menu_button {
  background-color: transparent;
  border: none;
  outline: none;
  margin-right: 70px;
}

</style>